import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import GeneralHelper from '../../helpers/General.js';

import moment from 'moment';

class Orders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            askDelete:false,
            orders:[],
            count:0,
            take:20,
            skip:0,
            max:0,
            current:1,
            pages:1,
            increment:20,
        }

        this.rows = this.rows.bind(this);
        this.getOrders = this.getOrders.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.renderNumbers = this.renderNumbers.bind(this);
        this.jumpPrev = this.jumpPrev.bind(this);
        this.jumpNext = this.jumpNext.bind(this);
    }

    jumpNext() {
        this.setState({
            skip:Math.round(this.state.skip+(7*this.state.increment))
        });
    }

    jumpPrev() {
        let to = this.state.skip-(7*this.state.increment);

        if(to < this.state.increment) {
            to = 0;
        }

        this.setState({
            skip:Math.round(to)
        });
    }

    switchPage(page) {
        this.setState({
            skip:page*this.state.increment
        });
    }

    paginatorNum(i) {
        return <li key={i} onClick={(e) => {e.stopPropagation(); this.switchPage(i);}} className={`page-item ${this.state.current == i ? 'active':''}`}><a className="page-link" href="javascript:void(0)">{i}</a></li>;
    }

    renderNumbers() {
        let elms = [];
        let i;
        let allowed_gap = 5;
        let pages_left = this.state.pages-this.state.current;
        let pages_prev = this.state.current-1;

        if(this.state.current > 1) {
            let prev_start_pos = 1;

            if((this.state.current-allowed_gap) > 1) {
                prev_start_pos = this.state.current-allowed_gap;
            }

            if(prev_start_pos > allowed_gap) {
                elms.push(<li key='jump-prev' onClick={this.jumpPrev} className={`page-item`}><a className="page-link" href="javascript:void(0)">...</a></li>);
            }

            for(i=prev_start_pos;i<=(this.state.current-1);i++) {
                console.dir(i);
                let elm = this.paginatorNum(i);
                elms.push(elm);
            }
        }

        if(pages_left > allowed_gap) {
            for(i=this.state.current;i<=(this.state.current+allowed_gap);i++) {
                let elm = this.paginatorNum(i);
                elms.push(elm);
            }
        }

        if(this.state.pages > 10) {
            elms.push(<li key='jump-next' onClick={this.jumpNext} className={`page-item`}><a className="page-link" href="javascript:void(0)">...</a></li>);
        }

        return elms;
    }

    placeholder() {
        return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
    }

    nextPage() {
        this.setState({
            skip:Math.round((parseInt(this.state.skip)+parseInt(this.state.increment))),
        });
    }

    prevPage() {
        this.setState({
            skip:Math.round((parseInt(this.state.skip)-parseInt(this.state.increment))),
        });
    }

    componentDidUpdate(props,state) {
        if(state.skip != this.state.skip) {
            this.getOrders();
        }
    }


    rows() {
        let data = this.placeholderRow(20,8);

        this.state.orders.map((order,i) => {
            data[i] =
                <tr key={`order-${order.id}`}>
                    <td>#{order.id}</td>
                    <td>{order.name}</td>
                    <td>{order.billing_address}</td>
                    <td>{order.billing_zip}</td>
                    <td>{order.billing_city}</td>
                    <td>{order.billing_country}</td>
                    <td>{order.total}</td>
                    <td>{moment(GeneralHelper.toLocalTime(order.created_at)).fromNow()}</td>
                </tr>

        })

        return data;
    }

    placeholderRow(rows,cols) {
        let td = [];
        for(let i = 1;i<=cols;i++) {
            td.push(<td key={i}>{this.placeholder()}</td>);
        }

        let row = [];
        for(let i = 1;i<=rows;i++) {
            row.push(<tr key={i}>{td}</tr>);
        }

        return row;
    }

    componentWillMount() {
        this.getOrders();
    }

    buildRequest() {
        let url = '/orders?';
        url += 'limit='+this.state.increment+'&skip='+this.state.skip;
        return url;
    }

    getOrders() {
        this.setState({
            isLoading:true,
        });

        axios.get(this.buildRequest())
            .then(res => {
                this.setState({
                    ...this.state,
                    'isError':false,
                    'isLoading':false,
                    'orders':res.data.orders,
                    'count':parseInt(res.data.count),
                    'take':parseInt(res.data.take),
                    skip:parseInt(res.data.skip),
                    max:parseInt(res.data.max),
                    current:parseInt(res.data.current),
                    pages:parseInt(res.data.pages),
                });
            })
            .catch(res => {
                this.setState({'isError':res.message});
            });
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        if(this.state.orders.length == 0) {
            return (

                <div className="page-content">
                    <Helmet title="Orders | Crall.io" />
                    <NoResult
                        header="No orders found"
                        body="Please come back in a while.."
                    />

                </div>
            );
        }

        return (
            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon wb-order"></i> Orders</span>
                </div>
                <div className="page-content">
                    <div className="col-sm-12 p-0">
                        <Helmet title="Orders | Crall.io" />

                        <div>
                            <div className="input-group">
                                <input type="text" className="form-control" name="" placeholder="Search..." />
                                <span className="input-group-btn">
                                    <button type="submit" className="btn btn-dark">
                                        <i className="icon wb-search" aria-hidden="true"></i>
                                    </button>
                                </span>
                            </div>
                        </div>

                        <table className="table outline">
                            <tbody>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Billing address</th>
                                <th>Billing zip</th>
                                <th>Billing city</th>
                                <th>Billing country</th>
                                <th>Total</th>
                                <th>Date</th>
                            </tr>
                            </tbody>



                            <tbody>
                            {this.rows()}
                            </tbody>
                        </table>

                        <nav style={{textAlign:'center'}}>
                            <ul className="pagination" style={{backgroundColor:'#fff'}}>
                                <li className="disabled page-item">
                                    <a className="page-link" onClick={this.prevPage} href="javascript:void(0)" aria-label="Previous">
                                        <span aria-hidden="true">«</span>
                                    </a>
                                </li>
                                {this.renderNumbers()}
                                <li className="page-item">
                                    <a className="page-link" onClick={this.nextPage} href="javascript:void(0)" aria-label="Next">
                                        <span aria-hidden="true">»</span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Orders = connect(mapStateToProps,mapDispatchToProps)(Orders);
export default Orders;


// WEBPACK FOOTER //
// ./containers/orders/orders.js